import { memo } from "react"
import styled from "styled-components"
import InvoiceTable from "./InvoiceTable"
import UpdateInvoiceModal from "./components/UpdateInvoiceModal"

const PageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  height: 100%;
`

const Invoice = () => {
  return (
    <PageContainer>
      <InvoiceTable />
      <UpdateInvoiceModal />
    </PageContainer>
  )
}

export default memo(Invoice)
